import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import { RootState } from "@/store";
import { handlePaginationData, queryRequest } from "@/utils/request";
import {
  lookDetail,
  traightCollarVouchersOrLuckyDraw
} from "@/graphql/get-coupons.gql";

export interface IGetCouponsState {
  promotion: any;
  promotionProducts: any[];
  activityCode: string;
}

@Module({ name: "GetCouponsModule", namespaced: true })
export default class GetCouponsModule
  extends VuexModule<IGetCouponsState, RootState>
  implements IGetCouponsState {
  // 活动
  public promotion = {};
  // 活动商品
  public promotionProducts = [];
  // 活动编号
  public activityCode: string = "";

  @Mutation
  saveActivityCodeMutation(data: string = "") {
    this.activityCode = data || "";
  }

  @Mutation
  savePromotionMutation(data = {}) {
    this.promotion = data;
  }
  @Mutation
  savePromotionProductsMutation(data = []) {
    this.promotionProducts = data || [];
  }

  // 清空页面数据
  @Action
  clearPageCacheDataAction() {
    const { commit } = this.context;
    commit("savePromotionMutation");
    commit("savePromotionProductsMutation");
    commit("saveActivityCodeMutation");
  }

  // 查询页面数据
  @Action
  async initDataAction() {
    const { state, commit } = this.context;
    const data = await queryRequest({
      query: lookDetail,
      variables: {
        activityCode: state.activityCode
      }
    });
    commit("savePromotionMutation", data);
  }

  // 领取
  @Action
  async pickCouponAction(variables: any = {}) {
    const { state, commit } = this.context;
    return await queryRequest({
      query: traightCollarVouchersOrLuckyDraw,
      variables: {
        activityCode: state.activityCode,
        ...variables
      }
    });
  }
}
